export function remainingLabel(dueAt, now = Date.now()) {
  const due = Date.parse(dueAt);
  if (!Number.isFinite(due)) return 'Срок не задан — обратитесь к менеджеру';
  const delta = due - now;
  const minutes = Math.ceil(Math.abs(delta) / 60000);
  const label = `${Math.floor(minutes / 60)} ч ${minutes % 60} мин`;
  return delta > 0 ? `До завершения: ${label}` : `Просрочено на ${label}`;
}